/**
 * Created by kongwm.kong on 2017/7/21.
 */

import Message from 'views/user/message'
//center 的子路由
export default [
    {
        path: 'message',
        component: Message,
        meta:{
            title:'消息中心-私募'
        },
        alias:'/message',
        name:'message'
    }
]


// WEBPACK FOOTER //
// ./src/routes/center.js